if (!customElements.get('plug-logo-animation')) {
    customElements.define('plug-logo-animation', class PlugLogoAnimation extends HTMLElement {
        constructor() {
            super();
            console.log("Logo Animation initiated")
            this.setVariable();
            this.initClone();
            document.addEventListener('scroll', this.animate.bind(this))
          window.addEventListener('resize', this.resize.bind(this))
        }
        setVariable() {
          this.announcement_height = Object.is(document.querySelector('.announcement-bar'), undefined) ? 0 : document.querySelector('.announcement-bar').offsetHeight;
          this.header_height = document.querySelector('header').offsetHeight;
          this.logo_height = this.offsetHeight;
          this.min_width = document.querySelector('.header__logo-image').offsetWidth;
          this.image = this.querySelector('img');
          this.max_width = this.offsetWidth;
          this.max_height = this.offsetHeight;
        }
        resize() {
          this.setVariable();
          this.animate();
        }
        initClone() {
            let container = document.querySelector('.header__logo');
            if (container.querySelector('a') != undefined)  {
                container = container.querySelector('a');
            }            

            this.clone = this.image.cloneNode(true);
            this.clone.style.top =  this.header_height;
            this.clone.classList.add('hidden');
            this.clone.classList.add('plug-logo-animation__clone');
            container.appendChild(this.clone);
            this.animate();
            setTimeout(() => {
              this.animate();
            }, 500)
        }
        animate() {
            const rect = this.getBoundingClientRect();
            this.logo_top = document.querySelector('.header__logo-image').getBoundingClientRect().top;
            let top = rect.top - this.header_height;
            let percentage = 0;
            console.log(top);
            if (this.logo_height == 0) {
              this.logo_height = this.offsetHeight;
              this.max_width = this.offsetWidth;
              this.max_height = this.offsetHeight;
            }
            if (top < 0 ) {
                this.clone.classList.remove('hidden');
                this.logo_height = this.offsetHeight;
                let total_height
                if (window.innerWidth < 1000) {
                  total_height = this.logo_height + 30;
                } else {
                  total_height = this.logo_height + 54;
                }
                let progress = (Math.abs(top) / total_height) * 100;
                console.log(total_height)
                if (progress >= 100) {
                    percentage = 0;
                } else {
                    percentage = 100 - progress;
                }

                console.log(progress)
                let width = this.max_width * (percentage / 100);
                let top_pos = this.header_height * (percentage / 100);
                console.log(width + " : " + top_pos)
                if (this.logo_top >= top_pos) {
                    top_pos = this.logo_top;
                }
                if (this.min_width >= width) {
                    width = this.min_width;
                }

                if (Math.abs(top) > this.max_height) {
                  top_pos = this.logo_top;
                }

  
                    
                    // apply styles to the button
                    if (Math.abs(top) > this.max_height) {
                      const styles = {
                        width: `${width}px`,
                        top: `0px`,
                        position: 'absolute'
                      }
                      Object.assign(this.clone.style, styles);
                    } else {
                      const styles = {
                        width: `${width}px`,
                        top: `${top_pos}px`,
                        position: 'fixed'
                      }
                      window.requestAnimationFrame(()=>{
                          Object.assign(this.clone.style, styles)
                          });
                    }
                
                this.classList.add('animated');
                
            } else {
                this.classList.remove('animated');
                this.clone.classList.add('hidden');
            }
        }
        isInViewport(element) {
            const rect = element.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        }
    })
}